import { css } from '@emotion/core';
import MediaQueries from '../../../../../styles/Grid/MediaQueries';

export const containerCss = css({
  width: '100%',
  position: 'absolute',
  marginTop: -64,
});

export const containerImageLeftCss = css({
  minHeight: 700,
  position: 'absolute',
  width: '100%',
});

export const containerImageRightCss = css({
  minHeight: 210,
  marginTop: 192,
  overflow: 'hidden',
  [MediaQueries.xl]: {
    minHeight: 404,
  },
});

export const imageLeftCss = css({
  height: 776,
  position: 'absolute',
  right: 0,
  width: 776,
});

export const imageRightCss = css({
  height: 404,
  width: 404,
});
